import { useFormikContext } from 'formik'
import ClickOutSide from 'hooks/click-outside'
import Paint from 'icons/paint'
import React, { useState } from 'react'
import { HexColorPicker } from 'react-colorful'

function ColorPicker({ name, label }) {
  const [openColorPicker, setOpenColorPicker] = useState(false)
  const formik = useFormikContext()
  return (
    <ClickOutSide onClickOutside={() => setOpenColorPicker(false)}>
      <div className='tw-grow tw-flex tw-flex-col tw-gap-[7px]'>
        <div className='tw-text-[#304861] tw-text-[15px] md:tw-text-[13px] tw-font-[500] tw-heading-[20px]'>
          {label}
        </div>
        <div
          onClick={() => setOpenColorPicker(!openColorPicker)}
          className='tw-bg-[#F2F5F5] tw-rounded-[5px] tw-min-h-[55px] md:tw-min-h-[40px] tw-px-[11px] tw-flex tw-items-center'
        >
          <div className='tw-grow tw-h-full tw-flex tw-items-center'>
            <div className=' tw-text-[16px] tw-placeholder-gray-300 md:tw-text-[14px] tw-w-full tw-rounded-regular tw-leading-regular tw-flex tw-items-center tw-justify-between tw-h-full'>
              <div className='tw-flex tw-items-center'>
                <span
                  className='tw-w-[18px] tw-h-[18px]  tw-mr-[8px] tw-flex tw-my-auto tw-rounded-sm'
                  style={{
                    background: formik.values[name],
                  }}
                ></span>
                {formik.values[name]}
              </div>
              <Paint />
            </div>
          </div>
        </div>
      </div>
      {openColorPicker && (
        <div className='tw-absolute tw-mt-1 tw-z-20'>
          <div className='tw-bg-white tw-border tw-w-min tw-border-slate-300 tw-drop-shadow-lg tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-4 tw-rounded-md'>
            <HexColorPicker
              color={formik.values[name]}
              onChange={(value) => formik.setFieldValue(name, value)}
              className='tw-mb-3'
            />
            <div class='tw-border tw-border-slate-300 tw-flex tw-items-stretch tw-rounded-md'>
              <div class='tw-bg-slate-100 tw-flex tw-items-center tw-px-3 tw-rounded-l-md tw-text-slate-500'>
                #
              </div>
              <input
                class='tw-border-l tw-border-slate-300 block tw-rounded-r-md tw-placeholder-gray-300 tw-p-1 tw-text-center tw-w-24'
                spellcheck='false'
                {...formik.getFieldProps(name)}
              />
            </div>
          </div>
        </div>
      )}
    </ClickOutSide>
  )
}

export default ColorPicker
